import React, { useState } from 'react';
import PropTypes from 'prop-types';

import InfoBox from '../InfoBox';

import { useRules } from '../../lib/rules';
import { parseTags, normaliseKey } from '../../lib/string';

const defaultInfo = {
  title: null,
  description: 'Click on a goal above and learn more about it here.',
};

const FragranceScreen = ({ state, step, onNext }) => {
  const [info, setInfo] = useState(step.info || null);

  const { heading, subHeading = null, extraClass, autoSubmit = true, field } = step;
  const { name = heading, component: FieldComponent, rules, ...props } = field;

  return (
    <div className={`quiz-section fragrance-screen ${extraClass ? extraClass : ''}`}>
      <div className="quiz-section-inner text-center">
        <div className="form-label-wrapper">
          <h3 className="form-label">{parseTags(heading, state)}</h3>
          {!!subHeading && <p>{subHeading}</p>}
        </div>
        <FieldComponent
          defaultValue={state[normaliseKey(name)] || ''}
          rules={Array.isArray(rules) && useRules(rules, state)}
          name={name}
          autoSubmit={autoSubmit}
          onOptionChange={(option) => {
            const { info: description = null } = option;

            if (typeof description === 'string' && description) {
              setInfo({ title: null, description });
            } else {
              setInfo(description || step.info || null);
            }
          }}
          onNext={onNext}
          {...props}
        />
      </div>
      {/* <div className="quiz-section-bottom">
        {info !== null && <InfoBox title={info.title} info={info.description} />}
        <div className="additional-info pt-3 pt-lg-4">
          <div className="legend">
            <img src="/app/themes/pvtl-child/dist/images/quiz/popular.svg" alt="Most Popular" />
            <p>Most popular</p>
          </div>
          <div className="legend">
            <img src="/app/themes/pvtl-child/dist/images/quiz/sensitive-skin.svg" alt="Sensitive Skin" />
            <p>For sensitivities</p>
          </div>
        </div>
        {info !== null && <div className="info-box-spacer" />}
      </div> */}
    </div>
  );
};

FragranceScreen.propTypes = {
  state: PropTypes.shape().isRequired,
  step: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string,
    info: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
    autoSubmit: PropTypes.bool,
    field: PropTypes.shape({
      name: PropTypes.string,
      component: PropTypes.elementType.isRequired,
      rules: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])),
    }),
  }).isRequired,
  onNext: PropTypes.func.isRequired,
};

export default FragranceScreen;
